import { Editor } from "grapesjs";
import { RequiredPluginOptions } from "../../../../../types/types";
import { html } from "../../../../../utils/tw";

export default async (editor: Editor, opts: RequiredPluginOptions) => {
  const { Components } = editor;

  Components.addType("term-condition", {
    model: {
      defaults: {
        components: html`
          <section class="container mx-auto px-4 md:px-12 py-12 text-gray-800">
            <div class="max-w-4xl mx-auto">
              <div class="flex gap-2 items-center mb-4">
                <div class="bg-amber-600 w-1 md:h-12 h-6 inline-block"></div>
                <h3
                  class="text-xl md:text-4xl text-[#0083D7] font-bold font-roboto p-1 tracking-normal whitespace-nowrap"
                >
                  Terms and Conditions
                </h3>
              </div>
              <p class="mb-4">
                By using our international cargo services, you agree to the
                following terms and conditions. Please read them carefully
                before booking your shipment.
              </p>

              <div class="space-y-6">
                <div>
                  <h3 class="text-xl font-semibold text-[#FF6700] mb-2">
                    1. General
                  </h3>
                  <p>
                    Our services are offered based on the acceptance of all
                    applicable international shipping laws, customs regulations,
                    and import/export restrictions of the destination country.
                  </p>
                </div>

                <div>
                  <h3 class="text-xl font-semibold text-[#FF6700] mb-2">
                    2. Liability
                  </h3>
                  <p>
                    We are not liable for any delay, loss, or damage caused by
                    events beyond our control, including but not limited to
                    natural disasters, customs delays, or airline disruptions.
                  </p>
                </div>

                <div>
                  <h3 class="text-xl font-semibold text-[#FF6700] mb-2">
                    3. Prohibited Items
                  </h3>
                  <p>
                    The following items are strictly prohibited: flammable
                    goods, explosives, firearms, perishable food, illegal drugs,
                    and counterfeit products. Any shipment found containing
                    prohibited items will be confiscated and reported to
                    authorities.
                  </p>
                </div>

                <div>
                  <h3 class="text-xl font-semibold text-[#FF6700] mb-2">
                    4. Packaging Responsibility
                  </h3>
                  <p>
                    It is the sender’s responsibility to ensure all goods are
                    packed securely to withstand international transit.
                    Improperly packaged items may not be eligible for insurance
                    claims.
                  </p>
                </div>

                <div>
                  <h3 class="text-xl font-semibold text-[#FF6700] mb-2">
                    5. Insurance
                  </h3>
                  <p>
                    Insurance is available upon request at an additional cost.
                    In case of loss or damage, claims must be filed within 7
                    working days from the delivery date.
                  </p>
                </div>

                <div>
                  <h3 class="text-xl font-semibold text-[#FF6700] mb-2">
                    6. Customs & Duties
                  </h3>
                  <p>
                    Customs clearance is the responsibility of the receiver. Any
                    duties, taxes, or customs charges imposed by the destination
                    country are to be borne by the receiver.
                  </p>
                </div>

                <div>
                  <h3 class="text-xl font-semibold text-[#FF6700] mb-2">
                    7. Delays
                  </h3>
                  <p>
                    Estimated delivery times are not guaranteed. External
                    factors such as weather, political situations, or border
                    issues may cause unforeseen delays.
                  </p>
                </div>

                <div>
                  <h3 class="text-xl font-semibold text-[#FF6700] mb-2">
                    8. Changes to Terms
                  </h3>
                  <p>
                    We reserve the right to modify these terms and conditions at
                    any time without prior notice. Please check this page
                    regularly for updates.
                  </p>
                </div>
              </div>

              <p class="mt-8 text-sm text-gray-500">
                If you have any questions about these terms, please contact our
                support team before shipping.
              </p>
            </div>
          </section>
        `,
        toolbar: [
          {
            attributes: { class: "fa fa-trash-o" },
            command: "tlb-delete",
          },
          {
            attributes: { class: "fa fa-gear" },
            command: "product-details-edit",
          },
        ],
      },
    },
  });
};
